import { render, h, Fragment } from 'preact';
import './patterns/mark';
import './patterns/coin';
import './patterns/i18n-text';
import './patterns/i18n-trans';
import './patterns/success';
import './patterns/error';
import './patterns/correct';
import { patternDecoders } from './patterns';
import { css } from '@emotion/css';

export const processPattern = (
  pattern: string,
  options?: {
    coinImage?: string;
    i18nParams?: Record<string, string | number>;
    customStyle?: {
      mark?: React.CSSProperties;
      coin?: React.CSSProperties;
      base?: React.CSSProperties;
      correct?: React.CSSProperties;
      span?: React.CSSProperties;
      [key: string]: any;
    };
    [key: string]: any;
  }
): string | preact.VNode => {
  // Default span styles to control width and appearance
  const defaultSpanStyles: React.CSSProperties = {
    color: '#FFF',
    display: 'inline-block',
    width: 'auto',
    minWidth: 'fit-content',
    whiteSpace: 'nowrap'
  };

  // Merge with custom span styles if provided
  const spanStyles = {
    ...defaultSpanStyles,
    ...options?.customStyle?.span
  };

  if (!pattern.includes('{slot-')) {
    return <span style={spanStyles}>{pattern}</span>;
  }

  const parts = [];
  let currentIndex = 0;

  while (currentIndex < pattern.length) {
    let earliestMatch = null;
    let earliestIndex = Infinity;
    let matchedDecoder = null;

    for (const [regex, decoder] of patternDecoders.entries()) {
      const patternText = regex.source.startsWith('^') ? regex.source.slice(1) : regex.source;
      const globalRegex = new RegExp(patternText, 'g');

      // Start searching from current position
      globalRegex.lastIndex = currentIndex;
      const match = globalRegex.exec(pattern);

      if (match && match.index < earliestIndex) {
        earliestMatch = match;
        earliestIndex = match.index;
        matchedDecoder = decoder;
      }
    }

    if (earliestMatch && matchedDecoder) {
      if (earliestIndex > currentIndex) {
        const textPart = pattern.substring(currentIndex, earliestIndex);
        parts.push(<span style={spanStyles}>{textPart}</span>);
      }

      parts.push(matchedDecoder(earliestMatch, options));

      currentIndex = earliestIndex + earliestMatch[0].length;
    } else {
      const remainingText = pattern.substring(currentIndex);
      parts.push(<span style={spanStyles}>{remainingText}</span>);
      break;
    }
  }

  const wrapperStyle = css`
        display: 'flex',
        alignItems: 'flex-start',
        gap: '4px',
        color: '#FFF',
        fontFamily: 'PingFangSC-Regular',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '18px',
        width: 'max-content'
  `;

  // Wrap with a flex container for alignment
  return parts.length === 1 ? parts[0] : <div className={wrapperStyle}>{parts}</div>;
};
